import { Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import Image1mob from './image-1-mob.svg'
import Image2mob from './image-2-mob.svg'
import Image3mob from './image-3-mob.svg'
import ImageDesk1x from './image-desk1x.png'
import ImageDesk2x from './image-desk2x.png'
import clsx from 'clsx'
import classes from './CodeArchitecture.module.scss'

export const CodeArchitecture = ({
  bgIsVisible,
  hasGradientBorder,
  className,
}: {
  bgIsVisible?: boolean
  hasGradientBorder?: boolean
  className?: string
}) => {
  return (
    <div className={classes.visual}>
      {bgIsVisible && <div className={classes.background} />}
      <div className={classes.caption}>
        <Text as={'span'} center className={classes.text}>
          Code
        </Text>
        <Text as={'span'} center className={classes.text}>
          Low Code
        </Text>
        <Text as={'span'} center className={classes.text}>
          No Code
        </Text>
      </div>
      <div
        className={clsx(
          classes.wrapper,
          hasGradientBorder && classes.wrapper__gradient,
          className,
        )}
      >
        <div className={clsx(classes.content, classes.content__mobile)}>
          <Text as={'span'} center className={classes.text}>
            Code
          </Text>
          <img
            className={clsx(classes.image, classes.image__mobile)}
            width={290}
            height={90}
            src={Image1mob.src}
            loading='lazy'
            alt='Code integration architecture'
          />
          <div className={classes.divider} />
          <Text as={'span'} center className={classes.text}>
            Low Code
          </Text>
          <img
            className={clsx(classes.image, classes.image__mobile)}
            width={254}
            height={140}
            src={Image2mob.src}
            loading='lazy'
            alt='Low code integration architecture'
          />
          <div className={classes.divider} />
          <Text as={'span'} center className={classes.text}>
            No Code
          </Text>
          <img
            className={clsx(classes.image, classes.image__mobile)}
            width={272}
            height={204}
            src={Image3mob.src}
            loading='lazy'
            alt='No code integration architecture'
          />
        </div>
        <div className={clsx(classes.content, classes.content__desktop)}>
          <Picture
            className={clsx(classes.image, classes.image__desktop)}
            deskSrc1x={ImageDesk1x.src}
            deskSrc2x={ImageDesk2x.src}
            width={1102}
            height={302}
            alt='Integration architecture'
            lazyLoad
          />
        </div>
      </div>
    </div>
  )
}
